export const LEVEL_BEGINNER = "beginner";
export const LEVEL_INTERMEDIATE = "intermediate";
export const LEVEL_EXPERT = "expert";

export const WEIGHTED_LEVELS = {
  [LEVEL_BEGINNER]: 0,
  [LEVEL_INTERMEDIATE]: 1,
  [LEVEL_EXPERT]: 2
};
